import { ArquivoAzure } from "../arquivo/ArquivoAzure";
import { AtividadePsicologoDeslocamento } from "../atividade-psicologo/atividade-psicologo-deslocamento";

export class JornadaPsicologoAntiga {
  codigoDiretoria: number;
  nomeDiretoria: string;
  codigoEscola: number;
  nomeEscola: string;
  codigoPsicologo?: number;
  nomePsicologo?: string;
  cpf?: string;
  dataInicio: Date;
  dataFim: string;
  JustificativaSolicitacao: string;
  Deslocamento?: AtividadePsicologoDeslocamento;
}
